import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitTaskGroupModel } from '@apps-common/types/portal/unit-tasks'

export const archiveUnitTaskGroup = async (model: IUnitTaskGroupModel): Promise<IUnitTaskGroupModel> =>
  axios.delete(`/management/UnitProgramTask/ArchiveTaskGroup?id=${model.id}`).then((res) => res?.data?.data)

type Props = {
  model: IUnitTaskGroupModel
}

export const useManagementArchiveUnitTaskGroup = (notify?: boolean, onSuccess?: (data: IUnitTaskGroupModel) => void) =>
  useMutation({
    mutationKey: ['archiveUnitTaskGroup'],
    mutationFn: ({ model }: Props) => archiveUnitTaskGroup(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Archived task.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to archive task.')
      }
    },
    throwOnError: false
  })
